import React from 'react';
import { PrimaryButton } from 'Core/components/Button';
import { useTranslation } from 'react-i18next';
import CloseIcon from 'Modules/deposit/components/CloseIcon';
import useAddCardForm from 'Modules/deposit/hooks/useAddCardForm';
import NewCard from 'Core/components/NewCard';
import TermsInput from 'Core/components/FormElements/TermsInput';
import Checkbox from 'Core/components/FormElements/Checkbox';
import Card from 'Core/components/FormElements/Card';

export default function AddCardForm({ onSubmit, className, onCancel, cardError }) {
  const { t } = useTranslation();

  const form = useAddCardForm();

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = form;

  return (
    <form
      name="addCardForm"
      onSubmit={handleSubmit(onSubmit)}
      className={`${className} space-y-4`}
      data-testid="add-card-form"
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
        <h3 className="text-lg font-semibold text-gray-900 m-0">{t('common.addCardDetails')}</h3>
        <CloseIcon onClick={onCancel} />
      </div>

      <Card className="!shadow-sm">
        <NewCard form={form} cardError={cardError} />
      </Card>

      <Card className="!shadow-sm">
        <TermsInput name="terms" register={register} errors={errors}>
          <p className="mb-0 text-gray-600">{t('terms.card.hold')}</p>
        </TermsInput>
        <div className="mt-4">
          <Checkbox label={t('common.markAsPreferredCard')} name="preferred" register={register} />
        </div>
      </Card>

      <div className="flex justify-end">
        <PrimaryButton
          type="submit"
          data-testid="save-card"
          size="tall"
          className="!shadow-md hover:!shadow-lg transition-shadow"
        >
          {t('common.saveCard')}
        </PrimaryButton>
      </div>
    </form>
  );
}
